(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xu-safety"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function leave(button) {
      var url = button.getAttribute('data-exit-url') || 'https://www.google.com';
      // replace() drops this page from history, so Back does not return to it
      window.location.replace(url);
    }

    function init(button) {
      if (button.dataset.xusReady === 'true') return;
      button.dataset.xusReady = 'true';
      button.addEventListener('click', function () { leave(button); });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') leave(button);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-xus-exit]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
